import React from 'react';
import DOMPurify from 'dompurify';
import { Card, Container, Dropdown, Form, DropdownButton, Button,  Accordion, Row, Col } from 'react-bootstrap';
import { FaBook , FaBlog, FaSearch, FaEdit, FaCheck, FaTags, FaExpandArrowsAlt} from 'react-icons/fa';

import classes from './NewBook.css';

const createMarkup = (html) => {
    return  {
      __html: DOMPurify.sanitize(html)
    }
  }

  
const blog = ( props ) => {
    let borderColor = props.complete ? "black" : "lightgray";
    var data = props.data;
    let statusIcon = props.complete ? <FaCheck /> : <FaEdit />;

    return (
      <div className={classes.Blog} style={{border:'1px solid '+borderColor}}>

<Form>
  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
    <Form.Label column sm="2">
      Book Name
    </Form.Label>
    <Col sm="6">
      <Form.Control type="text" id="bname" placeholder="Enter Book Name" />
    </Col>
  </Form.Group>

  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
    <Form.Label column sm="2">
      Author
    </Form.Label>
    <Col sm="6">
      <Form.Control type="text" id="author" placeholder="Enter Author Name" />
    </Col>
  </Form.Group>

  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
    <Col sm="10">
      <Button variant="secondary" size="lg" onClick={props.saveBook}>Add Book</Button>
      &nbsp;&nbsp;<button className="btn btn-warning px-8" style={{fontSize:"15px"}} onClick={props.cancelHandler.bind()}>Cancel</button>
    </Col>
  </Form.Group>
</Form>
      
      </div>

    );
};

export default blog;


// WEBPACK FOOTER //
// ./src/components/NewBook/NewBook.js